import { render, staticRenderFns } from "./EduLevelSelection.vue?vue&type=template&id=a5c7ba7c&"
import script from "./EduLevelSelection.vue?vue&type=script&lang=ts&"
export * from "./EduLevelSelection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports